import { render, staticRenderFns } from "./ngo-resources.vue?vue&type=template&id=6782087a&"
import script from "./ngo-resources.vue?vue&type=script&lang=js&"
export * from "./ngo-resources.vue?vue&type=script&lang=js&"
import style0 from "./ngo-resources.vue?vue&type=style&index=0&id=6782087a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports